import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const Skill = lazy(() => import('modules/admin/master/Skill'));

const SkillPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <Skill />
    </Suspense>
  </AdminLayout>
);

export default SkillPage;
